export default __webpack_public_path__ + "static/media/bootstrap.c79fd348.png";